import { Injectable } from "@angular/core";
import { RemoteGatewayFactory } from "../../gateways/remote-gateway-factory";
import { MedicalPrescriptionValidity } from "../../models/domains/pbm/Benefit/medical-prescription-validity";
import { BackendUrl } from "../../models/domains/urls/back-end.url";
import { MedicalPrescriptionValidityParser } from "../parsers/pbm/benefit/medical-prescription.parser";

@Injectable()
export class MedicalPrescriptionRepository {
  constructor(private remoteGatewayFactory: RemoteGatewayFactory, private medicalPrescriptionParser: MedicalPrescriptionValidityParser) {}

  public async getMedicalPrescriptionValidityList(): Promise<Array<MedicalPrescriptionValidity>> {
    const headers = {
      "Content-Type": "application/json",
    };
    try {
      const remoteGateway = this.remoteGatewayFactory.createDefaultRemoteGateway();
      const data = await remoteGateway.getWithHeaders(new BackendUrl("/api/benefit/configurations/medical-prescription/validities"), headers);
      return await Promise.resolve(this.medicalPrescriptionParser.parse(data));
    } catch (error) {
      return await Promise.reject(error);
    }
  }
}
